import { useToast } from '@kanda-libs/ks-design-library';
import { actions } from '@kanda-libs/ks-frontend-services';
import { useApiError, useAppDispatch, useShortUrlParams } from 'hooks';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

export interface ShortUrlHook {
  isLoading: boolean;
}

export default function useShortUrl(): ShortUrlHook {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { url } = useShortUrlParams();
  const { push } = useHistory();
  const { showError } = useToast();
  const dispatch = useAppDispatch();
  const onApiError = useApiError(
    'Unknown error with URL - please contact your tradesperson',
  );

  const urlRef = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (!url || url === urlRef.current) return;
    setIsLoading(true);
    urlRef.current = url;
    // if (urlRef.current) return;
    dispatch(
      actions.putInfoTag({
        body: { name: url },
        onError: (err) => {
          setIsLoading(false);
          onApiError(err);
        },
        onSuccess: (data) => {
          const { xurl } = data;
          if (!xurl) {
            setIsLoading(false);
            showError(
              'Error creating new enquiry, please refresh and try again. If this error persists, please contact Ideal4Finance',
            );
            return;
          }
          const redirectUrl = new URL(xurl);
          setTimeout(() => {
            push(redirectUrl.pathname);
          }, 100);
        },
      }),
    );
  }, [url, push, dispatch, onApiError, showError]);

  return {
    isLoading,
  };
}
